var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":8}},[_c('el-card',{attrs:{"shadow":"hover"}},[_vm._v(" 鼠标悬浮时显示 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }